
import { useState } from 'react';

export default function Home() {
  const [showConsultationForm, setShowConsultationForm] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentCaseStudy, setCurrentCaseStudy] = useState(0);

  const handleConsultationSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c7ni6enqf2o6v54fog', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowConsultationForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c7ni6enqf2o6v54fo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowContactForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  const caseStudies = [
    {
      id: 'beverage',
      industry: '飲料メーカー様',
      title: '2ステーションパレタイザーで人員削減・作業軽減を実現',
      description: '90秒/1ケースの処理能力で2時間無人稼働',
      results: [
        { icon: 'ri-time-line', text: '90秒/1ケースの処理能力' },
        { icon: 'ri-robot-line', text: '2時間無人稼働' },
        { icon: 'ri-team-line', text: '作業員3名から1名に削減' }
      ],
      image: 'https://readdy.ai/api/search-image?query=Industrial%20beverage%20factory%20with%20automated%20palletizer%20robot%20stacking%20beverage%20cases%20on%20pallets%2C%20modern%20production%20line%2C%20clean%20facility%20with%20stainless%20steel%20equipment%2C%20professional%20industrial%20photography%2C%20blue%20lighting&width=600&height=400&seq=case-study-beverage&orientation=landscape',
      link: '/case-studies#beverage'
    },
    {
      id: 'food',
      industry: '食品製造業様',
      title: '6パレット対応多関節ロボット導入',
      description: '500ケース/時の処理能力で多品種対応',
      results: [
        { icon: 'ri-speed-line', text: '500ケース/時の処理能力' },
        { icon: 'ri-stack-line', text: '6種類の製品を同時積み付け' },
        { icon: 'ri-refresh-line', text: '品種切り替え時間90%短縮' }
      ],
      image: 'https://readdy.ai/api/search-image?query=Multi-axis%20articulated%20robot%20in%20food%20manufacturing%20facility%20handling%20various%20packaged%20products%2C%20flexible%20automation%20system%2C%20clean%20food%20processing%20environment%2C%20multiple%20product%20types&width=600&height=400&seq=case-food&orientation=landscape',
      link: '/case-studies#food'
    },
    {
      id: 'logistics',
      industry: '物流センター様',
      title: '省スペース直交ロボット導入',
      description: '300ケース/時で24時間無人稼働を実現',
      results: [
        { icon: 'ri-dashboard-line', text: '300ケース/時の処理能力' },
        { icon: 'ri-time-line', text: '24時間無人稼働' },
        { icon: 'ri-building-line', text: '設置面積40㎡で実現' }
      ],
      image: 'https://readdy.ai/api/search-image?query=Compact%20cartesian%20robot%20palletizer%20in%20logistics%20warehouse%2C%20space-saving%20automation%20solution%2C%20organized%20storage%20facility%20with%20efficient%20layout%2C%20modern%20logistics%20center&width=600&height=400&seq=case-logistics&orientation=landscape',
      link: '/case-studies#logistics'
    },
    {
      id: 'chemical',
      industry: '化学工業様',
      title: '大型機械式パレタイザー導入',
      description: '800ケース/時で重量物の安全な積み付け',
      results: [
        { icon: 'ri-speed-line', text: '800ケース/時の処理能力' },
        { icon: 'ri-weight-line', text: '50kg重量物対応' },
        { icon: 'ri-shield-check-line', text: '労災事故ゼロ継続' }
      ],
      image: 'https://readdy.ai/api/search-image?query=Heavy-duty%20mechanical%20palletizer%20in%20chemical%20plant%2C%20robust%20industrial%20equipment%20handling%20heavy%20packages%2C%20safety-focused%20industrial%20environment%2C%20large-scale%20manufacturing%20facility&width=600&height=400&seq=case-chemical&orientation=landscape',
      link: '/case-studies#chemical'
    }
  ];

  const nextCaseStudy = () => {
    setCurrentCaseStudy((prev) => (prev + 1) % caseStudies.length);
  };

  const prevCaseStudy = () => {
    setCurrentCaseStudy((prev) => (prev - 1 + caseStudies.length) % caseStudies.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-800 text-white py-4 px-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <h1 className="text-2xl font-bold" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</h1>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
            <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
            <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
            <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
            <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
            <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
            <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
          </nav>

          <div className="flex items-center space-x-6">
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              見積依頼・お問い合わせ
            </button>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-slate-700">
            <nav className="flex flex-col space-y-4 mt-4">
              <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
              <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
              <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
              <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
              <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
              <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
              <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
              <button 
                onClick={() => {
                  setShowConsultationForm(true);
                  setMobileMenuOpen(false);
                }}
                className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors text-left"
              >
                見積依頼・お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 41, 59, 0.7), rgba(30, 41, 59, 0.7)), url('https://readdy.ai/api/search-image?query=Modern%20industrial%20factory%20with%20robotic%20palletizer%20system%20stacking%20cardboard%20boxes%20on%20wooden%20pallets%2C%20automated%20warehouse%20environment%20with%20conveyor%20belts%2C%20professional%20lighting%2C%20clean%20industrial%20setting%2C%20blue%20and%20gray%20color%20scheme%2C%20high-tech%20manufacturing%20facility&width=1920&height=1080&seq=hero-palletizer&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-6xl font-bold mb-6 leading-tight">
            パレット積み付け作業の<br />
            <span className="text-orange-400">人手不足、解決します</span>
          </h1>
          <p className="text-2xl mb-8 text-slate-200">
            年間人件費大幅削減。パレタイザー導入で24時間無人稼働を実現
          </p>
          <div className="flex justify-center space-x-6 mb-8">
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-12 py-4 rounded-lg text-xl font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              お問い合わせはこちら
            </button>
            <button 
              onClick={() => setShowContactForm(true)}
              className="bg-blue-600 hover:bg-blue-700 px-12 py-4 rounded-lg text-xl font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              資料ダウンロード
            </button>
          </div>
          <div className="text-xl font-bold text-orange-400">
            <i className="ri-trophy-line mr-2"></i>
            1,000社以上の導入実績
          </div>
        </div>
      </section>

      {/* Problems Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">
            こんなお悩み、ありませんか？
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              'パレット積み付けの人手が足りない',
              '重労働で作業者の負担が大きい',
              '積み付けミスで荷崩れが発生',
              '夜勤・残業コストが膨らんでいる'
            ].map((problem, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg border-l-4 border-red-500">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-close-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg font-semibold text-slate-700">{problem}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">
            パレタイザーがすべて解決します
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {[
              '24時間無人稼働で人件費削減',
              '正確な積み付けでミス防止',
              '作業者の負担軽減・安全性向上',
              '年間最大500万円のコスト削減実績'
            ].map((solution, index) => (
              <div key={index} className="bg-blue-50 p-8 rounded-lg shadow-lg border-l-4 border-blue-600">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg font-semibold text-slate-700">{solution}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-10 py-4 rounded-lg text-lg font-bold text-white whitespace-nowrap cursor-pointer transition-colors"
            >
              詳しく聞く
            </button>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-slate-800 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16">
            パレタイザーナビが選ばれる4つの理由
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-trophy-line',
                title: '豊富な実績',
                desc: '1,000社以上の導入実績'
              },
              {
                icon: 'ri-tools-line',
                title: '専門知識',
                desc: '創業以来の技術力'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'トータルサポート',
                desc: '設計から保守まで一貫対応'
              },
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'コスト最適化',
                desc: '複数メーカーから最適機種を選定'
              }
            ].map((reason, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${reason.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
                <p className="text-slate-300">{reason.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Study Section (dynamic carousel) */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">導入事例</h2>
          <div className="relative">
            <div className="bg-slate-50 rounded-lg p-8 shadow-lg">
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-slate-800 mb-4">{caseStudies[currentCaseStudy].industry}</h3>
                  <h4 className="text-xl font-semibold text-blue-600 mb-4">{caseStudies[currentCaseStudy].title}</h4>
                  <p className="text-lg text-slate-600 mb-6">
                    {caseStudies[currentCaseStudy].description}
                  </p>
                  <div className="space-y-4 mb-6">
                    {caseStudies[currentCaseStudy].results.map((result, index) => (
                      <div key={index} className="flex items-center">
                        <i className={`${result.icon} text-blue-600 mr-3`}></i>
                        <span className="text-slate-700">{result.text}</span>
                      </div>
                    ))}
                  </div>
                  <a 
                    href={caseStudies[currentCaseStudy].link}
                    className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg text-white font-bold whitespace-nowrap cursor-pointer transition-colors inline-block"
                  >
                    詳細を見る
                  </a>
                </div>
                <div className="relative">
                  <img 
                    src={caseStudies[currentCaseStudy].image}
                    alt={caseStudies[currentCaseStudy].industry}
                    className="w-full h-80 object-cover rounded-lg shadow-lg"
                  />
                </div>
              </div>
            </div>

            {/* Navigation buttons */}
            <button 
              onClick={prevCaseStudy}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-slate-100 w-12 h-12 rounded-full shadow-lg flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-line text-xl text-slate-700"></i>
            </button>
            <button 
              onClick={nextCaseStudy}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-slate-100 w-12 h-12 rounded-full shadow-lg flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-arrow-right-line text-xl text-slate-700"></i>
            </button>

            {/* Indicators */}
            <div className="flex justify-center mt-6 space-x-2">
              {caseStudies.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentCaseStudy(index)}
                  className={`w-3 h-3 rounded-full cursor-pointer transition-colors ${
                    index === currentCaseStudy ? 'bg-blue-600' : 'bg-slate-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Product Types Section (with links) */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">
            お客様に最適な機種をご提案
          </h2>
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                type: '機械式',
                feature: '高処理能力',
                target: '飲料業界向け',
                image: 'https://readdy.ai/api/search-image?query=Mechanical%20palletizer%20machine%20in%20beverage%20factory%2C%20high-speed%20automated%20stacking%20system%2C%20industrial%20equipment%20with%20conveyor%20belts%2C%20professional%20manufacturing%20environment%2C%20metallic%20finish&width=400&height=300&seq=mechanical-palletizer&orientation=landscape',
                link: '/selection-guide#mechanical'
              },
              {
                type: '多関節ロボット',
                feature: '柔軟性高',
                target: '多品種対応',
                image: 'https://readdy.ai/api/search-image?query=Multi-axis%20articulated%20robot%20arm%20palletizer%20handling%20various%20box%20sizes%2C%20flexible%20automation%20system%2C%20modern%20warehouse%20setting%2C%20advanced%20robotics%20technology%2C%20precise%20movements&width=400&height=300&seq=articulated-robot&orientation=landscape',
                link: '/selection-guide#articulated'
              },
              {
                type: '直交ロボット',
                feature: '省スペース・低コスト',
                target: '中小企業向け',
                image: 'https://readdy.ai/api/search-image?query=Cartesian%20coordinate%20robot%20palletizer%20in%20compact%20factory%20space%2C%20space-saving%20automation%20solution%2C%20cost-effective%20industrial%20equipment%2C%20clean%20modern%20facility&width=400&height=300&seq=cartesian-robot&orientation=landscape',
                link: '/selection-guide#cartesian'
              }
            ].map((product, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={product.image}
                  alt={product.type}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-2">{product.type}</h3>
                  <p className="text-blue-600 font-semibold mb-2">{product.feature}</p>
                  <p className="text-slate-600 mb-4">{product.target}</p>
                  <a 
                    href={product.link}
                    className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg text-white font-bold whitespace-nowrap cursor-pointer transition-colors inline-block"
                  >
                    詳細を見る
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Information Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">
            パレタイザーについて詳しく知りたい方へ
          </h2>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
            {[
              {
                title: 'パレタイザーの基礎知識',
                description: '基本的な仕組みとメリットを詳しく解説',
                icon: 'ri-book-open-line',
                link: '/palletizer-basics',
                bgColor: 'bg-blue-100',
                iconColor: 'text-blue-600',
                linkColor: 'text-blue-600'
              },
              {
                title: '機種選定ガイド',
                description: '3つのタイプの詳細比較',
                icon: 'ri-settings-line',
                link: '/selection-guide',
                bgColor: 'bg-green-100',
                iconColor: 'text-green-600',
                linkColor: 'text-green-600'
              },
              {
                title: '導入判断の6つの基準',
                description: '失敗しない選び方',
                icon: 'ri-checkbox-multiple-line',
                link: '/decision-criteria',
                bgColor: 'bg-purple-100',
                iconColor: 'text-purple-600',
                linkColor: 'text-purple-600'
              },
              {
                title: '導入事例集',
                description: '業界別の成功事例',
                icon: 'ri-building-line',
                link: '/case-studies',
                bgColor: 'bg-orange-100',
                iconColor: 'text-orange-600',
                linkColor: 'text-orange-600'
              },
              {
                title: 'メーカー・製品紹介',
                description: '主要メーカーと製品ラインナップ',
                icon: 'ri-factory-line',
                link: '/manufacturers-products',
                bgColor: 'bg-indigo-100',
                iconColor: 'text-indigo-600',
                linkColor: 'text-indigo-600'
              },
              {
                title: '周辺機器・システム',
                description: 'トータルソリューション',
                icon: 'ri-tools-line',
                link: '/peripheral-systems',
                bgColor: 'bg-teal-100',
                iconColor: 'text-teal-600',
                linkColor: 'text-teal-600'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg border border-slate-200 hover:shadow-xl transition-shadow cursor-pointer">
                <a href={item.link} className="block p-8 text-center">
                  <div className={`w-16 h-16 ${item.bgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                    <i className={`${item.icon} text-2xl ${item.iconColor}`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">{item.title}</h3>
                  <p className="text-slate-600 mb-4">{item.description}</p>
                  <div className={`${item.linkColor} font-semibold flex items-center justify-center`}>
                    詳しく見る
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">導入までの流れ</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '1', title: '無料相談', desc: '現状ヒアリング', icon: 'ri-chat-3-line' },
              { step: '2', title: '現地調査', desc: '設置条件確認', icon: 'ri-search-line' },
              { step: '3', title: '提案・見積', desc: '最適機種選定', icon: 'ri-file-text-line' },
              { step: '4', title: '設置・稼働', desc: 'アフターサポート', icon: 'ri-settings-3-line' }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${process.icon} text-2xl text-white`}></i>
                </div>
                <div className="text-2xl font-bold text-blue-600 mb-2">STEP {process.step}</div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">{process.title}</h3>
                <p className="text-slate-600">{process.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">よくあるご質問</h2>
          <div className="space-y-4">
            {[
              {
                q: '導入費用の目安はどのくらいですか？',
                a: '機種や仕様により異なりますが、1,500万円～3,000万円程度です。補助金活用のご相談も承っております。'
              },
              {
                q: '設置期間はどのくらいかかりますか？',
                a: '現地調査から稼働開始まで約3～6ヶ月です。既存ラインとの調整により期間が変動する場合があります。'
              },
              {
                q: '既存ラインとの連携は可能ですか？',
                a: 'はい、既存の搬送ラインやWMSとの連携も可能です。現地調査時に詳しく確認いたします。'
              },
              {
                q: 'メンテナンス体制はどうなっていますか？',
                a: '24時間365日のサポート体制を整えており、定期メンテナンスから緊急対応まで対応いたします。'
              },
              {
                q: '操作は難しくないですか？',
                a: '直感的な操作パネルを採用しており、導入時には操作研修も実施いたします。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full p-6 text-left flex justify-between items-center cursor-pointer hover:bg-slate-50"
                >
                  <span className="font-semibold text-slate-800">{faq.q}</span>
                  <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-slate-600`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-6">
                    <p className="text-slate-600">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strong CTA Section */}
      <section className="py-20 bg-orange-500 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">まずは無料相談から始めませんか？</h2>
          <div className="text-5xl font-bold mb-8">03-1234-5678</div>
          <p className="text-xl mb-8">平日 9:00-18:00 / 土日祝日も対応可能</p>
          <div className="flex justify-center space-x-6 mb-8">
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-white text-orange-500 hover:bg-slate-100 px-10 py-4 rounded-lg text-xl font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              お問い合わせフォーム
            </button>
            <button 
              onClick={() => setShowContactForm(true)}
              className="bg-slate-800 hover:bg-slate-700 px-10 py-4 rounded-lg text-xl font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              資料ダウンロード
            </button>
          </div>
          <p className="text-lg">現地調査も無料で対応いたします</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</h3>
              <p className="text-slate-300 mb-4">パレタイザー専門企業として、製造業・物流業の自動化をサポートします。</p>
              <div className="flex space-x-4">
                <i className="ri-phone-line text-orange-400"></i>
                <span>03-1234-5678</span>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">サービス</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">機械式パレタイザー</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">多関節ロボット</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">直交ロボット</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">保守・メンテナンス</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">詳細情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/palletizer-basics" className="hover:text-orange-400 cursor-pointer">パレタイザーとは</a></li>
                <li><a href="/decision-criteria" className="hover:text-orange-400 cursor-pointer">導入判断基準</a></li>
                <li><a href="/case-studies" className="hover:text-orange-400 cursor-pointer">導入事例</a></li>
                <li><a href="/manufacturers-products" className="hover:text-orange-400 cursor-pointer">メーカー・製品</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">周辺機器・システム</a></li>
                <li><a href="/alternatives-comparison" className="hover:text-orange-400 cursor-pointer">代替案・比較</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">会社情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li>〒174-0000 東京都板橋区</li>
                <li>設立：1985年</li>
                <li>従業員数：120名</li>
                <li>ISO9001認証取得</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
            <p>&copy; 2024 パレタイザーナビ. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-orange-400 hover:text-orange-300 ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Consultation Form Modal */}
      {showConsultationForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">お問い合わせ・見積もり</h3>
                <button 
                  onClick={() => setShowConsultationForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="consultation-form" data-readdy-form onSubmit={handleConsultationSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">電話番号 *</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">業種</label>
                  <select name="industry" className="w-full p-3 pr-8 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="">選択してください</option>
                    <option value="食品・飲料">食品・飲料</option>
                    <option value="化学・医薬品">化学・医薬品</option>
                    <option value="物流・倉庫">物流・倉庫</option>
                    <option value="その他製造業">その他製造業</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">現在の課題・ご要望</label>
                  <textarea 
                    name="requirements" 
                    rows={4} 
                    maxLength={500}
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="現在の作業状況や導入を検討している理由をお聞かせください（500文字以内）"
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">希望連絡方法</label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="電話" className="mr-2" />
                      電話
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="メール" className="mr-2" />
                      メール
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="どちらでも" className="mr-2" defaultChecked />
                      どちらでも
                    </label>
                  </div>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">資料ダウンロード</h3>
                <button 
                  onClick={() => setShowContactForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="contact-form" data-readdy-form onSubmit={handleContactSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                  <input 
                    type="email" 
                    name="email" 
                    required 
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">ご希望の資料</label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="パレタイザー総合カタログ" className="mr-2" />
                      パレタイザー総合カタログ
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="導入事例集" className="mr-2" />
                      導入事例集
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="コスト削減効果資料" className="mr-2" />
                      コスト削減効果資料
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="補助金活用ガイド" className="mr-2" />
                      補助金活用ガイド
                    </label>
                  </div>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  資料をダウンロード
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
